import React from 'react';
import { Link } from 'react-router-dom';
import { track, events } from '../../lib/analytics';

const FinalCTA = () => {
  return (
    <section
      id="call"
      className="relative py-28 md:py-32 overflow-hidden"
      style={{
        backgroundImage:
          "linear-gradient(135deg, rgba(26,32,53,0.82) 0%, rgba(52,71,103,0.72) 100%), url('https://images.unsplash.com/photo-1668677417604-7484eafa7153?w=1920&q=80')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='140' height='140'><circle cx='70' cy='70' r='1' fill='%23ffffff'/></svg>\")",
        }}
      />
      <div className="relative max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-white font-black tracking-[-0.01em] leading-[1.1] text-[32px] sm:text-[42px] md:text-[48px]">
          Give us 15 minutes. We'll find the revenue in your advertiser list.
        </h2>
        <p className="mt-6 text-slate-300 text-[16px] leading-[1.75]">
          A 15-minute call with one of our publishing revenue experts. We'll look at your advertiser base, show you what a lead generation line would realistically contribute, and tell you honestly if it's not a fit. No deck. No follow-up sequence. Bring your scepticism.
        </p>
        <div className="mt-10">
            <Link
              to="/contact"
              data-testid="final-cta-grab-15-btn"
              onClick={() => track(events.GRAB_15_CALL_CLICK, { location: 'final_cta' })}
              className="inline-flex items-center justify-center h-12 px-8 rounded-md bg-brand-pink hover:bg-brand-pink/90 text-white text-[13px] font-bold uppercase tracking-[0.08em] shadow-mk hover:shadow-mk-lg hover:-translate-y-0.5 transition-all duration-300"
            >
              Grab a 15-minute call
            </Link>
        </div>
        <p className="mt-5 text-slate-400 text-[13.5px]">
          Prefer email first? Download the playbook above and come back when you're ready.
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
